import { useEffect } from 'react';

const OrderComplete = ({ orderCompleteUrl }: { orderCompleteUrl: string }) => {
  useEffect(() => {
    setTimeout(() => {
      window.location.href = orderCompleteUrl;
    }, 2000);
  }, []);

  return (
    <div className="container single-page-checkout">
      <div className="order-complete width-100 bs-bb">
        <div className="order-content">
          <h1>Completing your Order...</h1>
          <div className="loader" />
        </div>
      </div>
    </div>
  );
};

export default OrderComplete;
